module.exports = __webpack_public_path__ + "static/media/lottery5_banner.32975755.png";